import { GiveawayDetailsRoute } from "@/features/home/route";
import { formatDate } from "@/lib/date";
import { capitalizeFirstLetter } from "@/lib/string";
import { useNavigate } from "react-router-dom";
import { Promotion } from "../models/giveaway";
import PrizeTag from "./price-tag";

interface UpcomingPrizeProps {
	giveaway: Promotion;
}

const UpcomingPrize: React.FC<UpcomingPrizeProps> = ({ giveaway }) => {
	const navigate = useNavigate();
	const baseURL = import.meta.env.VITE_SERVER_API_URL;
	const prizeImage = `${baseURL}/common/image/${giveaway.prize.images[0].url}`;

	const handleClick = () => {
		navigate(`${GiveawayDetailsRoute}?id=${giveaway.id}`);
	};

	return (
		<div
			className="flex cursor-pointer flex-col gap-8 text-left"
			onClick={handleClick}
		>
			<div
				className="h-50 w-full rounded-[32px] p-3 md:h-113 md:w-120 md:p-6"
				style={{
					backgroundImage: `url('${prizeImage}')`,
					backgroundRepeat: "round",
				}}
			>
				<div className="flex flex-col gap-2 md:flex-row md:gap-4">
					<PrizeTag>{capitalizeFirstLetter(giveaway.type.toString())}</PrizeTag>
					<PrizeTag>{formatDate(giveaway.startDate)}</PrizeTag>
				</div>
			</div>
			<div className="flex flex-col gap-2">
				<p className="web-body-b2-medium text-white-80">
					Valued AT ${giveaway.prize.cost.toLocaleString()}
				</p>
				<p className="web-heading-h4 text-white">{giveaway.prize.title}</p>
			</div>
		</div>
	);
};

export default UpcomingPrize;
